// @ts-nocheck
export const maxLineQtyRule = ({ max = 50 } = {}) => ({
  name: 'max-line-qty',
  validate(cartState = null, mutation = null) {
    return {
      allowed: true,
      modifiedMutation: mutation,
    };
  },
});
